var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VLabeledToggle',{attrs:{"items":_vm.versions,"default-index":_vm.currentIndex},on:{"click-item":_vm.onClickItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }